import abstractModel from '../../../core/MercatelyModel';
import { MERCATELY_API_V2 } from '../../../constants/AppConstants';

// Resources
const resource = `${MERCATELY_API_V2}/chat_actions/`;

// Model
const model = abstractModel(resource);

// Methods
model.readChat = async ({ id, ...body }) => model.put(body, { path: `${resource}read_chat` });

model.unreadChat = async (body) => model.put(body, { path: `${resource}unread_chat` });

model.assignAgent = async (body) => model.put(body, { path: `${resource}assign_agent` });

model.changeStatus = async (body) => model.put(body, { path: `${resource}change_status` });

model.toggleChatBot = async ({ id, ...body }) => model.put(body, { path: `${resource}${id}/toggle_chat_bot` });

model.toggleBlockUser = async ({ id }) => model.put({}, { path: `${resource}${id}/toggle_block_user` });

model.retrieveMiaSources = async (params) => model.get(params, { path: `${MERCATELY_API_V2}/chat_actions/retrieve_mia_sources_responses` });

model.createCustomer = async (body) => model.post(body, { path: `${resource}create_customer` });

export default model;
